<template>
<!--会员状态-->
  <div id="personvip">
    <h2 class="title">
      <router-link :to="{name: 'PersonInfo'}" class="prev"></router-link>
      教师资格会员
      <a href="" class="rule">会员规则</a>
    </h2>
    <div class="profile">
      <span class="avatar"></span>
      <div>
        <h3>18600670910 <img src="../../assets/icon/personvip_icon_vip0.png" alt=""></h3>
        <p>当前未开通会员</p>
      </div>
    </div>
    <div class="ad-vip">
      <h4>教师资格会员卡</h4>
      <p>掌握解题技巧，助力领证</p>
      <h6>
        <b>136932</b>人已开通
      </h6>
      <a href="" class="buy">开通会员</a>
    </div>
    <!--会员权益-->
    <div class="benefit">
      <h2>会员权益</h2>
      <ul>
        <li>
          <img src="../../assets/icon/personvip_icon_benefit1.png" alt="">
          <h5>考题视频解析</h5>
          <p>1500+考题精讲</p>
        </li>
        <li>
          <img src="../../assets/icon/personvip_icon_benefit2.png" alt="">
          <h5>名师经典课程</h5>
          <p>100+课程畅听</p>
        </li>
        <li>
          <img src="../../assets/icon/personvip_icon_benefit3.png" alt="">
          <h5>试卷考点分析</h5>
          <p>理解考题更深刻</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonVip',
  data () {
    return {
    }
  },
  methods: {
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  #personvip
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
      a.rule
        position: absolute
        top: .1rem
        right: .32rem
        font-size: .26rem
        color: #333
        font-weight: 500
    .profile
      display: flex
      justify-content: flex-start
      align-items: center
      width: 7.5rem
      height: 1.66rem
      border-top: .04rem solid #E7E8E9
      padding: .48rem .4rem .26rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      span.avatar
        display: block
        width: .92rem
        height: .92rem
        background: url(../../assets/img/personvip_img_avatar.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
      h3
        margin-left: .32rem
        font-size: .32rem
        color: #333
        img
          position: relative
          top: .02rem
          left: .05rem
          width: .66rem
          height: .32rem
      p
        margin-left: .32rem
        font-size: .24rem
        color: #A3A9B7
    .ad-vip
      position: relative
      width: 6.7rem
      height: 2.32rem
      background: url(../../assets/img/personvip_bg_ad_vip.png) no-repeat center
      padding: .2rem 0 0 .48rem
      margin: 0 auto
      -webkit-border-radius: .15rem
      -moz-border-radius: .15rem
      border-radius: .15rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      h4
        font-size: .32rem
        color: #333
        font-weight: 600
      p
        margin-top: .08rem
        font-size: .22rem
        color: #333
      h6
        margin-top: .52rem
        font-size: .26rem
        b
          font-size: .32rem
          color: #333
      a.buy
        position: absolute
        bottom: .18rem
        right: .16rem
        display: block
        width: 2.16rem
        height: .72rem
        line-height: .72rem
        background-color: rgba(255, 255, 255, .5)
        font-size: .32rem
        color: #333
        font-weight: 600
        text-align: center
        -webkit-border-radius: .36rem
        -moz-border-radius: .36rem
        border-radius: .36rem
    .benefit
      width: 7.5rem
      height: 3.02rem
      background-color: #fff
      border-top: .16rem solid #F9F9F9
      border-bottom: .16rem solid #F9F9F9
      margin-top: .28rem
      h2
        margin: .48rem 0 .28rem
        font-size: .32rem
        color: #333
        font-weight: 600
        text-align: center
      ul
        display: flex
        justify-content: space-around
        align-items: center
        li
          text-align: center
          img
            width: .44rem
            height: .52rem
          h5
            font-size: .26rem
            color: #333
          p
            font-size: .22rem
            color: #9DA4B3
</style>



// WEBPACK FOOTER //
// src/components/personal/PersonVip.vue